import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useAppContext } from '../../../context';
import { Iac } from '../../../globals/interfaces';
import { notify } from '../../../utils';
import ActionIcon from '../../custom/ActionIcon';

import IacModal from './IacModal';
import ModalUploadCsv from './ModalUploadCsv';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import apiClient from '../../../apiClient';
import VirtualTable from '../../custom/VirtualTable';

interface Props {
    activeTabId: string;
}

export default function IacTab ({
    activeTabId
}: Props) {

    const { user } = useAppContext();
    const [data, setData] = useState<Array<Iac>>([]);
    const [modal, setModal] = useState(false);
    const [modalUpload, setModalUpload] = useState(false);
    const [selectedItem, setSelectedItem] = useState<Iac>();

    useEffect(() => {
        const getIacData = async () => {
            const res = await apiClient.get('/iacCcsf/iac');
            if (res.status === 200) {
                setData(res.data);
            }
        }
        if (activeTabId === 'iac' && data.length === 0) {
            getIacData();
        }
    }, [activeTabId, data]);

    const manageItem = (selectedItem?: Iac) => {
        if (selectedItem) {
            setSelectedItem(selectedItem);
        } else {
            setSelectedItem(undefined);
        }
        setModal(true);
    }

    const createItem = async (data: Iac) => {
        const res = await apiClient.post('/iacCcsf/iac', data);
        if (res.status === 200) {
            notify('Created');
            setData(prev => {
                const copy = _.cloneDeep(prev);
                copy.push(res.data);
                return copy;
            });
            setModal(false);
        }
    }

    const updateItem = async (data: Iac) => {
        const res = await apiClient.put('/iacCcsf/iac', data);
        if (res.status === 200) {
            notify('Updated');
            setData(prev => {
                const copy = _.cloneDeep(prev);
                const updateIndex = copy.findIndex(item => item.id === data.id);
                copy[updateIndex] = res.data;
                return copy;
            });
            setModal(false);
        }
    }

    const handleCreateUpdate = (update: boolean, data: Iac) => {
        const fn = update ? updateItem : createItem;
        fn(data);
    }

    const deleteItem = async (id: number) => {
        const res = await apiClient.delete(`/iacCcsf/iac/${id}`);
        if (res.status === 204) {
            notify('Deleted');
            setData(prev => {
                const filtered = prev.filter(item => item.id !== id);
                return filtered;
            });
            setModal(false);
        }
    }

    const uploadCsv = async (data: Array<any>) => {
        try {
            console.log(data);
            const res = await apiClient.post(`/iacCcsf/iac-upload`, data);
            const { message, newData } = res.data;
            setModalUpload(false);
            notify(message);
            setData(newData);
        } catch (err) {
            notify(err, 'error');
        }
    }

    return (
        <div>
            <FlexContainer>
                <ActionIcon
                    type={'add'}
                    onClick={manageItem}
                />
                <ActionIcon
                    type={'upload'}
                    onClick={() => setModalUpload(true)}
                />
            </FlexContainer>
            <VirtualTable
                data={data}
                mapping={[{
                    name: 'Number',
                    value: 'approval_number'
                }, {
                    name: 'Carrier',
                    value: 'indirect_carrier_name'
                }, {
                    name: 'IACSSP_08_001',
                    value: 'IACSSP_08_001'
                }, {
                    name: 'City',
                    value: 'city'
                }, {
                    name: 'State',
                    value: 'state',
                    customWidth: 50
                }, {
                    name: 'Zip code',
                    value: 'postal_code',
                    customWidth: 150
                }, {
                    name: 'Expiration',
                    value: 'expiration_date',
                    date: true,
                    utc: true,
                    sortMethod: (a: string, b: string) => +new Date(a) - +new Date(b)
                }, {
                    name: 'Valid',
                    value: 'valid',
                    boolean: true,
                    customWidth: 50
                }]}
                index
                enableClick
                handleClick={manageItem}
            />
            <IacModal
                modal={modal}
                setModal={setModal}
                selectedItem={selectedItem}
                handleCreateUpdate={handleCreateUpdate}
                deleteItem={deleteItem}
                user={user}
            />
            <ModalUploadCsv
                modal={modalUpload}
                setModal={setModalUpload}
                type={'iac'}
                submit={uploadCsv}
            />
        </div>
    );
}

export const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
`;